@if (isDev) {
    <button mat-mini-fab class="tdt-fab" color="primary" (click)="toggle()" matTooltip="Toggle Theme (dev only)">
        @if (theme() === "arcus") {
            <fa-icon icon="moon" size="lg"></fa-icon>
        }
        @if (theme() === "arcusDark") {
            <fa-icon icon="sun" size="lg"></fa-icon>
        }
    </button>
}
